import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Paula',
    quote: 'Las recetas son súper fáciles y los budines quedan increíbles.'
  }, {
    name: 'Carolina',
    quote: 'Probé varias recetas y todas salieron perfectas.'
  }, {
    name: 'Laura',
    quote: 'Ahora siempre preparo budines para la merienda.'
  }];
  return <section className="py-20 px-4 bg-[#FFF8F0]" data-id="element-263">
      <div className="max-w-4xl mx-auto" data-id="element-264">
        <div className="text-center mb-16" data-id="element-265">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#3D2B1F]" data-id="element-266">
            ⭐ Lo que dicen quienes{' '}
            <span className="text-[#D4850A]" data-id="element-267">ya lo probaron</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-268">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-2xl border border-[#E8D5C4] flex flex-col shadow-md text-center" data-id="element-269">
              <div className="flex gap-1 mb-4 justify-center" data-id="element-270">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#D4850A] fill-[#D4850A]" data-id="element-271" />)}
              </div>
              <p className="text-[#6B5344] italic mb-6 flex-1 text-lg" data-id="element-272">
                "{testimonial.quote}"
              </p>
              <p className="font-bold text-[#3D2B1F] text-lg" data-id="element-273">
                — {testimonial.name}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}